module.exports = __webpack_public_path__ + "static/tasks-web5-111d9f5fbada51192542c033840fbbab.png";